import { Actions } from './groupeActions';

/**
 * Etat initial groupes
 */
const initialState = {
    groupes: {
        items: [],
        isLoading: false
    }
};

/**
 * Reducer pour les groupes
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        case Actions.FETCH_GROUPES_REQUEST:
            return {
                ...state,
                groupes: { ...state.groupes, isLoading: true }
            };
        case Actions.FETCH_GROUPES_SUCCESS:
            return {
                ...state,
                groupes: { ...state.groupes, items: [...action.items], isLoading: false }
            };
        case Actions.FETCH_GROUPES_FAILURE:
            return {
                ...state,
                groupes: { ...state.groupes, isLoading: false, error: action.error }
            };

        default:
            return state;
    }
};

export default reducer;